//handles redux exhibitor state
import {createSlice} from '@reduxjs/toolkit';

const initialStateValue = ''

export const loginUsernameSlice = createSlice({
    name:"loginUsername",
    initialState:{value:initialStateValue},
    reducers:{
        rxLoginUsername:(state,action)=>{
            state.value = action.payload
        },
    }
})

export const {rxLoginUsername} = loginUsernameSlice.actions

export default loginUsernameSlice.reducer;
